<template>
    <!-- 头部 -->
    <div class="header">
    <div class="bg-color">
        <div class="main">
            <div class="left">
                <div class="logo" @click="goHome">
                    <img src="../../assets/image/logo.png" alt="">
                </div>
                <div class="banner">
                    <div class="ban-item" v-for="item,index in bannarList" :key="item.id" :class="banIndex==index?'active':''" @click="handleBannar(item,index)">
                        <div>{{item.name}}</div>
                        <div class="name"></div>
                    </div>
                </div>  
            </div>
            <div class="my-login">
                <Login  :isDaoba="false"/>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import Login from '@comm/components/LoginTag.vue'
export default {
    props: {
    },
    components: {
        Login
    },
    data() {
        return {
            banIndex: 1,
            bannarList:[
                {
                    id:1,
                    name: '首页',
                    path:"/"
                },
                {
                    id:2,
                    name: '竞赛项目',
                    path:"/project"
                },
                {
                    id:3,
                    name: '赛程赛果',
                    path:"/schedule"
                },
                {
                    id:4,
                    name: '代表团',
                    path:"/delegation/"
                },
                {
                    id:5,
                    name: '场馆指南',
                    path:"/stadium"

                },
                {
                    id:6,
                    name: '最美九龙坡',
                    path:"/beautifulJiulong"
                },
            ]
        }
    },
    mounted () {

    },
    methods: {
        goHome(){
            this.$router.push('/')
        },
        handleBannar(item,index) {
            this.bannarIndex = index;
            this.$router.push(item.path);
            localStorage.setItem('menuIndex',index);
        },
    },
    watch: {

    },

}
</script>

<style lang="scss" scoped>
//导航
.header {
    width: 100%;
    position: absolute;
    z-index: 1;
    .bg-color {
        width: 100%;
        height: 60px;
        background-color: rgba(0, 0, 0,0.5);
        .main{
            width: 1200px;
            margin: 0 auto;
            position: relative;
            display: flex;
            justify-content: space-between;
            .left{
                color: #ffffff;
                height: 60px;
                display: flex;
                justify-content: flex-start;
                .logo{
                    height: 100%;
                    cursor: pointer;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    margin-right: 30px;
                    img{
                        width: 50px;
                        margin-top: 5px;
                    }
                    .h-name{
                        width: 80px;
                        height: 100%;
                        font-size: 16px;
                        font-weight: 500;
                        color: #fff;
                        text-align: center;
                    }
            
                }
                .banner{
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    .ban-item{
                        // width: 120px;
                        height: 60px;
                        cursor: pointer;
                        padding: 20px;
                        text-align: center;
                        margin-right: 30px;
                       
                    }
                    .active{
                         .name{
                            margin-top: 5px;
                            border-bottom: 2px solid #ffffff;
                        }
                    }
                    .ban-item:hover{
                        .name{
                            margin-top: 5px;
                            border-bottom: 2px solid #ffffff;
                        }
                    }
                }
           }
            .my-login{
                padding-top:10px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/district/components/common/MatchHeader.vue